// styles & fonts
import "bootstrap/dist/css/bootstrap.min.css";
import "normalize.css";
import React from "react";
import { createRoot } from 'react-dom/client';
import AppLauncher from "src/app/AppLauncher";
import "./css/bootstrap-grid.css";
import "./css/fonts.css";
import "./css/iconStyle.css";
import "./css/fer-ge.css";
import "./fonts/Montserrat-Medium.ttf";
import "./fonts/Montserrat-Regular.ttf";
import "./fonts/Montserrat-SemiBold.ttf";
import "./index.css";

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  // TODO strictMode + react 18 provoques double renders at start (and call rest services twice
  // remove strickMode if this is happening in a non dev environment : https://stackoverflow.com/questions/61254372/my-react-component-is-rendering-twice-because-of-strict-mode
  <React.StrictMode>
    <AppLauncher />
  </React.StrictMode>
);

